import { doc, getDoc, updateDoc, setDoc, Timestamp } from "firebase/firestore";
import { db } from "../../services/firebase";

const SNOOZE_DAYS = 30;

export const getMFAReminderSnoozed = async (userId: string): Promise<boolean> => {
    try {
        const docRef = doc(db, "mfaReminders", userId);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
            const data = docSnap.data();
            const snoozedUntil = data.snoozedUntil?.toDate();
            if (snoozedUntil && snoozedUntil > new Date()) {
                return true;
            }
        }
        return false;
    } catch (error) {
        console.error("Error fetching MFA reminder: ", error);
        return false;
    }
}

export const snoozeMFAReminder = async (userId: string): Promise<void> => {
    try {
        const docRef = doc(db, "mfaReminders", userId);
        const snap = await getDoc(docRef);
        const snoozedUntil = Timestamp.fromDate(new Date(Date.now() + SNOOZE_DAYS * 24 * 60 * 60 * 1000));
        if (snap.exists()) {
            await updateDoc(docRef, { snoozedUntil });
        } else {
            await setDoc(docRef, { snoozedUntil }, { merge: true });
        }
    } catch (error) {
        console.error("Error snoozing MFA reminder: ", error);
    }
}